
import objectPath from 'object-path'
import initialStateInsurance from './initialState'
import { cart } from '@/utils/mapping'

const mutations = {
  clearInsuranceState(state) {
    state.insurances = []
  },
  setInsuranceInitial(state) {
    state.insurances.push(initialStateInsurance())
  },
  setInsurances(state, { insuranceIndex, data: { searchId, results } }) {
    const collection = results.map(item => cart.medicalInsurance(item))

    state.insurances[insuranceIndex].serviceLoaded = true

    const current = {
      slug: null,
      name: 'Не выбрано',
      price: {
        amount: 0,
        markup: 0,
        currency: collection[0].price.currency
      }
    }

    collection.unshift(current)

    state.insurances[insuranceIndex].insurances = {
      ...state.insurances[insuranceIndex].insurances,
      isLoading: false,
      current,
      searchId,
      collection
    }
  },
  updateInsuranceCurrent(state, { target, value }) {
    state.insurances[target].insurances.current = (
      state.insurances[target].insurances.collection.find(item => item.slug === value)
    )
  },
  setInsurancesPenalties(state, { target, penalties }) {
    objectPath.set(state, `${target}.penalties`, {
      ...objectPath.get(state, `${target}.penalties`),
      isLoading: false,
      collection: penalties
    })
  },
}

export default mutations